import script from "./select-flavors.vue?vue&type=script&setup=true&lang=js"
export * from "./select-flavors.vue?vue&type=script&setup=true&lang=js"

import "./select-flavors.vue?vue&type=style&index=0&id=564a879d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564a879d"]])

export default __exports__